import { useMemo } from "react";
import AOMultiDropdown from "../../components/AOMultiDropdown";

const options = [
  {
    value: "Head Office",
    subOptions: [
      {
        value: "Finance",
      },
      {
        value: "Marketing",
      },
      {
        value: "People",
      },
      {
        value: "Product",
      },
      {
        value: "Technology",
      },
      {
        value: "Warehouse",
      },
      {
        value: "Other",
      },
    ],
  },
  {
    value: "Optometrist",
    subOptions: [
      {
        value: "Clinical",
      },
      {
        value: "Locum",
      },
      {
        value: "Optical",
      },
      {
        value: "Other",
      },
    ],
  },
  {
    value: "Partnership",
    subOptions: [
      {
        value: "Retail",
      },
    ],
  },
  {
    value: "Retail",
    subOptions: [
      {
        value: "Area Management",
      },
      {
        value: "Optical",
      },
      {
        value: "Store Management",
      },
      {
        value: "Other",
      },
    ],
  },
];

const matches = (option, name) =>
  option.value.toLowerCase() === name.trim().toLowerCase();

// Selection for a category name (e.g. from ?category=Optometrist) with all its subcategories checked,
// or only the named one (e.g. ?category=Retail&subcategory=Store+Management)
export const categorySelection = (name, subName) => {
  const option = name && options.find((o) => matches(o, name));
  if (!option) return [];

  const subOptions = subName
    ? option.subOptions.filter((o) => matches(o, subName))
    : [];
  // An unknown subcategory is ignored, leaving the whole category selected
  return [
    Object.assign({}, option, subOptions.length ? { subOptions } : null),
  ];
};

const CategoryFilter = ({ jobs, defaultValue, onChange }) => {
  // Counted fresh from jobs (not added onto the shared options) so reloading jobs can't double them
  const countedOptions = useMemo(
    () =>
      options.map((option) => ({
        ...option,
        subOptions: option.subOptions.map((subOption) => ({
          ...subOption,
          count: jobs.filter(
            (j) =>
              j.category === option.value &&
              (j.subcategory ?? "Other") === subOption.value
          ).length,
        })),
      })),
    [jobs]
  );

  return (
    <AOMultiDropdown
      placeholder={"Select a category"}
      options={countedOptions}
      defaultValue={defaultValue}
      onChange={onChange}
    />
  );
};

export default CategoryFilter;
